import { createTfRecordParams } from '@/views/business/utils.js'
const util = {
    subjects: {
        expense_nature_id:'', // 费用nature
        customer_function_id: '', // 员工职能
        customer_type: '', // 员工类型
        item_type_id: '', // 产品类型
        fund_usage_id: 0, // 资金用途
        is_insider_trading: false, // 内部交易
        account_title_id: '', // 会计科目
        analysis_title_id: '', // 分析科目
    },
    new_contract: {
        is_soho:false,
        is_electronic: false, // 是否是电子合同
        uid: '',
        platform: 'yunzhanghu',
        account: '',
        apply_user_id: 0,
        apply_user: 0,
        fill_user_id: 0,
        fill_user: '',
        region: '',
        mobile: '',
        id_number: '',
        company_id: 0,
        team_id: 0,
        job_content: '',
        is_remote: false,
        settlement_type: '',
        estimate_price: 0.00,
        payment_type: 'bank',
        alipay: '',
        bank_number: '',
        bank_branch: '',
        contract_start: '',
        contract_end: '',
        expense_type_id: 0,
        contract_files: [],
        id_files: [],
        payment_files: [],
        archive_files: [],
        quantitative_output: null,
        ads_record_ids: [], // 投放记录
        placing_ads_vas_records: [],
    },
    getSettlementType(type) {
        let text;
        switch (type) {
            case 'by_piece':
                text = '按月计件';
                break;
            case 'daily_wage':
                text = '按月日薪';
                break;
            case 'month_wage':
                text = '固定月薪';
                break;
            case 'per_time':
                text = '按次结算';
                break;
            default:
                text = '未定义结算方式';
                break;
        }
        return text;
    },
    platforms: [
        {
            label: '云账户',
            value: 'yunzhanghu'
        },
        {
            label: '51社保',
            value: 'shebao51'
        }
    ],
    getPlatformName(val) {
        let platform = '';
        switch (val) {
            case 'yunzhanghu':
                platform = '云账户';
                break;
            case 'shebao51':
                platform = '51社保';
                break;
            default:
                platform = '未定义平台';
                break;
        }
        return platform;
    },
    getDetail(id) {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.outsource_contract_detail, {
                params: {
                    id: id
                }
            }).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getPayeeCompanyAccount(id_number, bank_number) {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.outsource_payee_company_account, {
                params: {
                    id_number: id_number,
                    bank_number: bank_number
                }
            }).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getMyValidContract() {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.query_my_valid_outsource_contract).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getMyExpiredContract() {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.query_my_expired_outsource_contract).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    },
    getWageTopics(params) {
        return new Promise((resolve, reject) => {
            Util.ajax.get(Util.api.query_outsource_wage_topic, {
                params: params
            }).then((response) => {
                return response.data;
            }).then((res) => {
                if (res.code === 1) {
                    resolve(res.data);
                } else {
                    reject({message: res.msg});
                }
            }).catch((e) => {
                reject(e);
            });
        });
    }
};

export default util;
